
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useParams } from "react-router-dom";
import LanguageCard from "../../../components/layout-new-theme/LanguageCard";

const logo_brand = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/tlf-logo-brand.svg";

const MemorandumPage = (props) => {
  const { t } = useTranslation();
  const [_, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setIsLoading(false);
  }, [location]);

  const isLangJP = localStorage.getItem("lang") === "JP";

  return (
    <div className="memorandum">
      <div style={{ position: "fixed", top: 20, right: 20, zIndex: 999 }}>
        <LanguageCard />
      </div>
      <div
        className="hero-image-memorandum tw:flex tw:items-center tw:relative"
        style={{
          backgroundImage: `url('https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/images/memorandum-banner.png')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '290px'
        }}
      >
        <div className="tw:absolute" style={{ top: '20px', left: '20px', zIndex: 10 }}>
          <img src={logo_brand} alt="TLF Logo" />
        </div>

        <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-3/4 tw:lg:flex-none tw:relative" style={{ zIndex: 5 }}>
          <div className="tw:px-[calc(var(--gx)/2)] tw:w-full tw:flex-none tw:flex tw:flex-col tw:justify-end tw:text-center">
            <p className="tw:opacity-75 tw:mb-2 text-gold" style={{ fontSize: '8px', letterSpacing: '3px', textTransform: 'uppercase' }}>
              {t('memorandum.header.subtitle')}
            </p>
            <h1 className="tw:text-white! tw:font-light! tw:mb-6 tw:mt-2" style={{ fontSize: '34px', letterSpacing: '1px', lineHeight: '45px' }}>
              {t('memorandum.header.title')}
            </h1>
          </div>
        </div>
      </div>
      <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:w-[91.6667%] tw:md:flex-none tw:lg:w-full tw:lg:flex-none tw:py-12 tw:px-4 tw:md:px-0">
        <p>
          {t('memorandum.preamble')}
        </p>

        <section>
          <div>{t('memorandum.sections.conditions.title')}</div>
          <p>{t('memorandum.sections.conditions.description')}</p>

          <h3>{t('memorandum.sections.conditions.corporationsJapan.title')}</h3>
          <ol>
            <li>{t('memorandum.sections.conditions.corporationsJapan.item1')}</li>
            <li>
              {t('memorandum.sections.conditions.corporationsJapan.item2')}
            </li>
          </ol>

          <h3>{t('memorandum.sections.conditions.corporationsOutsideJapan.title')}</h3>
          <ol>
            <li>
              {t('memorandum.sections.conditions.corporationsOutsideJapan.item1')}
            </li>
            <li>
              {t('memorandum.sections.conditions.corporationsOutsideJapan.item2')}
            </li>
          </ol>
        </section>

        <section>
          <div>{t('memorandum.sections.calculationOfFare.title')}</div>
          <p>
            {t('memorandum.sections.calculationOfFare.description')}
          </p>
        </section>

        <section>
          <div>{t('memorandum.sections.commission.title')}</div>
          <p>
            {t('memorandum.sections.commission.description')}
          </p>
        </section>

        <section>
          <div>{t('memorandum.sections.commissionAdjustment.title')}</div>
          <p>
            {t('memorandum.sections.commissionAdjustment.description')}
          </p>
        </section>

        <section>
          <p>{t('memorandum.sections.payment.title')}</p>

          <h3>{t('memorandum.sections.payment.corporationsJapan.title')}</h3>
          <p>
            {t('memorandum.sections.payment.corporationsJapan.description')}
          </p>

          <h3>{t('memorandum.sections.payment.corporationsOutsideJapan.title')}</h3>
          <p>
            {t('memorandum.sections.payment.corporationsOutsideJapan.description')}
            <div>
              {t('memorandum.sections.payment.corporationsOutsideJapan.additionalInfo')}
            </div>
          </p>
        </section>

        <section>
          <div>{t('memorandum.sections.cancellationPolicy.title')}</div>
          <ul>
            {t('memorandum.sections.cancellationPolicy.oneVehicle.title')}
            <li style={{ listStyle: 'none' }}>
              <ul>
                <li>{t('memorandum.sections.cancellationPolicy.oneVehicle.item1')}</li>
                <li>{t('memorandum.sections.cancellationPolicy.oneVehicle.item2')}</li>
                <li>{t('memorandum.sections.cancellationPolicy.oneVehicle.item3')}</li>
                <li>{t('memorandum.sections.cancellationPolicy.oneVehicle.item4')}</li>
              </ul>
            </li>
          </ul>
          <ul>
            {t('memorandum.sections.cancellationPolicy.twoToFourVehicles.title')}
            <li style={{ listStyle: 'none' }}>
              <ul>
                <li>{t('memorandum.sections.cancellationPolicy.twoToFourVehicles.item1')}</li>
                <li>{t('memorandum.sections.cancellationPolicy.twoToFourVehicles.item2')}</li>
                <li>{t('memorandum.sections.cancellationPolicy.twoToFourVehicles.item3')}</li>
                <li>{t('memorandum.sections.cancellationPolicy.twoToFourVehicles.item4')}</li>
              </ul>
            </li>
          </ul>

          <ul>
            {t('memorandum.sections.cancellationPolicy.fiveOrMoreVehicles.title')}
            <li style={{ listStyle: 'none' }}>
              <ul>
                <li>{t('memorandum.sections.cancellationPolicy.fiveOrMoreVehicles.item1')}</li>
                <li>{t('memorandum.sections.cancellationPolicy.fiveOrMoreVehicles.item2')}</li>
                <li>{t('memorandum.sections.cancellationPolicy.fiveOrMoreVehicles.item3')}</li>
                <li>{t('memorandum.sections.cancellationPolicy.fiveOrMoreVehicles.item4')}</li>
              </ul>
            </li>
          </ul>

          {isLangJP ? (
            <ul>
              {t('memorandum.sections.cancellationPolicy.agreementPrecedence.title')}
              <li style={{ listStyle: 'none' }}>
                <ul>
                  {t('memorandum.sections.cancellationPolicy.agreementPrecedence.description')}
                </ul>
              </li>
            </ul>
          ) : (
            <ul>
              {t('memorandum.sections.cancellationPolicy.agreementPrecedence.description')}
            </ul>
          )}


          <ul>
            {t('memorandum.sections.cancellationPolicy.scopeOfApplication.title')}
            <p>
              {t('memorandum.sections.cancellationPolicy.scopeOfApplication.description')}
            </p>
          </ul>

          <ul>
            {t('memorandum.sections.cancellationPolicy.forceMajeure.title')}
            <p>
              {t('memorandum.sections.cancellationPolicy.forceMajeure.description1')}
              <br />
              {t('memorandum.sections.cancellationPolicy.forceMajeure.description2')}
            </p>
          </ul>
        </section>

        <section>
          <div>{t('memorandum.sections.scheduleChanges.title')}</div>
          <ul>
            <li>
              {t('memorandum.sections.scheduleChanges.higherAmount')}
            </li>
            <li>
              {t('memorandum.sections.scheduleChanges.lowerAmount')}
            </li>
          </ul>
        </section>
        <section>
          <div>{t('memorandum.sections.scopeOfApplicationStandalone.title')}</div>
          <p>
            {t('memorandum.sections.scopeOfApplicationStandalone.description')}
          </p>
        </section>
        <section>
          <div>{t('memorandum.sections.meetService.title')}</div>
          <p>
            {t('memorandum.sections.meetService.item1')}
            <br />
            {t('memorandum.sections.meetService.item2')}
            <br />
            {t('memorandum.sections.meetService.item3')}
            <br />
            {t('memorandum.sections.meetService.item4')}
            <br />
            {t('memorandum.sections.meetService.item5')}
          </p>
        </section>

        <section>
          <div>{t('memorandum.sections.vipMeetService.title')}</div>
          <p>
            {t('memorandum.sections.vipMeetService.item1')}
            <br />
            {t('memorandum.sections.vipMeetService.item2')}
            <br />
            {t('memorandum.sections.vipMeetService.item3')}
            <br />
            {t('memorandum.sections.vipMeetService.item4')}
          </p>
        </section>

        <section>
          <div>{t('memorandum.sections.conciergeFee.title')}</div>
          <p>{t('memorandum.sections.conciergeFee.description')}</p>
        </section>

        <section>
          <div>{t('memorandum.sections.accidents.title')}</div>
          <div>
            {t('memorandum.sections.accidents.description')}
          </div>
          <ul className="tw:mb-0">
            <li>{t('memorandum.sections.accidents.coverage')}</li>
          </ul>
        </section>

        <section>
          <div>{t('memorandum.sections.contractPeriod.title')}</div>
          <p>
            {t('memorandum.sections.contractPeriod.description')}
          </p>
        </section>

        <section>
          <div>{t('memorandum.sections.termination.title')}</div>
          <p>{t('memorandum.sections.termination.description')}</p>
        </section>

        <section>
          <div>{t('memorandum.sections.jurisdictionalCourt.title')}</div>
          <p>
            {t('memorandum.sections.jurisdictionalCourt.description')}
          </p>
        </section>

        <section>
          <div>{t('memorandum.sections.consultation.title')}</div>
          <p>
            {t('memorandum.sections.consultation.description')}
          </p>
        </section>
      </div>
    </div>
  );
};

export default MemorandumPage;